/**
 * Correspondences Service Barrel Export
 *
 * Central export point for all correspondence-related functionality.
 */

// Types
export * from './types';

// Actions (Server-side)
export {
  getMatterCorrespondencesAction,
  getCorrespondenceAction,
  getCorrespondenceByInstitution,
  createCorrespondenceAction,
  bulkCreateCorrespondencesAction,
  updateCorrespondenceAction,
  deleteCorrespondenceAction,
  sendCorrespondenceAction,
  previewLetterAction,
  processIncomingEmailAction,
  regenerateLetterAction
} from './actions';

// Utilities
export {
  // Formatting
  formatCorrespondenceType,
  formatCorrespondenceStatus,

  // Cache management
  getCorrespondencesCacheKey,
  getCorrespondenceCacheKey,

  // Export functions
  exportCorrespondencesToCSV
} from './utils';

// Hooks (Client-side)
export {
  useMatterCorrespondences,
  useCorrespondence,
  useCreateCorrespondence,
  useBulkCreateCorrespondences,
  useUpdateCorrespondence,
  useDeleteCorrespondence,
  useSendCorrespondence,
  useMatterCorrespondencesService
} from './hooks';
